import { render, staticRenderFns } from "./Input-fields.vue?vue&type=template&id=0af53f6c"
import script from "./Input-fields.vue?vue&type=script&lang=js"
export * from "./Input-fields.vue?vue&type=script&lang=js"
import style0 from "./Input-fields.vue?vue&type=style&index=0&id=0af53f6c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af53f6c')) {
      api.createRecord('0af53f6c', component.options)
    } else {
      api.reload('0af53f6c', component.options)
    }
    module.hot.accept("./Input-fields.vue?vue&type=template&id=0af53f6c", function () {
      api.rerender('0af53f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/Input-fields.vue"
export default component.exports